/** @jsxImportSource @emotion/react */
import React, {useCallback, useEffect, useMemo, useState} from 'react';

import {css} from '@emotion/react';
import {useDispatch} from 'react-redux';

import {updateLoading} from '@/actions/loadingActions';
import {showKeyboard, showPopUp, hidePopUp} from '@/actions/modalActions';
import {showAlert} from '@/actions/setupActions';
import {PostRequest} from '@/api/request';
import CheckBox from '@/components/checkBox/CheckBox';
import InputField from '@/components/inputfield/InputField';
import {POST_CONNECT_TO_WIFI, POST_FORGET_WIFI} from '@/constants/apis';
import {ButtonColor, ButtonSize, fontSize, proteinConcentrationColor, roundCorner} from '@/constants/appStyle';
import {ALERT_TYPE, WIFI_ERROR} from '@/constants/enums';
import {SYSTEM_SETTING} from '@/constants/messages';
import {
  FONT_SIZE as FontSize,
  PASSWORD as Password,
  FORGET_BUTTON as Forget,
  CONNECT_BUTTON as ConnectButton,
  CONNECT_LOADING as ConnectLoading,
  SSID,
  SECURITY,
  SECURITY_TYPE,
  OK,
  CONNECT_ADD_NETWORK,
} from '@/constants/pcConstAppData';
import {COLUMN_FULL} from '@/constants/pcConstAppStyle';
import {useWifiListContext} from '@/contexts/WifiListContext';
import {useChangeWifiSettingContext, useWifiSettingContext} from '@/contexts/WifiSettingContext';

import {GenerateSequenceSelector} from '../../manualProfile/components/SequenceTypeUpdate';

import './WifiConfig.less';

export function WifiConfig() {
  const dispatch = useDispatch();
  const {selectedWifi, isConnecting} = useWifiSettingContext();
  const {SetSelectedWifi, SetIsConnecting} = useChangeWifiSettingContext();
  const {changeWifiListValues} = useWifiListContext();

  const [isShowInputPassword, setIsShowInputPassword] = useState(false);
  const [wifiPassword, setWifiPassword] = useState(selectedWifi.Password);
  // /**
  //  * @deprecated current info of the root cause is the current password field component is not able to display the value when on click the display button
  //  */
  // const [showPassword] = useState('text');
  const [networkSSID, setNetworkSSID] = useState('');

  const [newSecurityType, setNewSecurityType] = useState('');
  const [selectedSecurityId] = useState('');
  const [securityType, setSecurityType] = useState(SECURITY_TYPE.NONE);
  const [saveSecurity, setSaveSecurity] = useState(false);
  const [isDisableSaveBtn, setIsDisableSetBtn] = useState(true);
  const [isAutoConnectHidden, setIsAutoConnectHidden] = useState(false);
  const [isSelectedEncryptionOn, setIsSelectedEncryptionOn] = useState(false);

  const SECURITY_TYPES = {
    [SECURITY_TYPE.NONE]: {
      value: SECURITY_TYPE.NONE,
      label: SECURITY_TYPE.NONE,
      active: securityType === SECURITY_TYPE.NONE,
    },
    [SECURITY_TYPE.WEP]: {
      value: SECURITY_TYPE.WEP,
      label: SECURITY_TYPE.WEP,
      active: securityType === SECURITY_TYPE.WEP,
    },
    [SECURITY_TYPE.WPA2]: {
      value: SECURITY_TYPE.WPA2,
      label: SECURITY_TYPE.WPA2,
      active: securityType === SECURITY_TYPE.WPA2,
    },
    [SECURITY_TYPE.WPA3]: {
      value: SECURITY_TYPE.WPA3,
      label: SECURITY_TYPE.WPA3,
      active: securityType === SECURITY_TYPE.WPA3,
    },
  };

  useEffect(() => {
    if (networkSSID === '' || networkSSID === undefined || (securityType !== SECURITY_TYPE.NONE && !wifiPassword)) {
      setIsDisableSetBtn(true);
    } else {
      setIsDisableSetBtn(false);
    }
  }, [securityType, networkSSID, wifiPassword]);

  const canForget = useMemo(
    () =>
      // return selectedWifi.Password !== null
      selectedWifi.HasBeenConnected,
    [selectedWifi, networkSSID, selectedWifi.Password],
  );

  const isAddNetwork = useMemo(() => selectedWifi.Name === 'Add Network', [selectedWifi]);

  useEffect(() => {
    setIsSelectedEncryptionOn(selectedWifi.IsEncryptionOn);
    if (isShowInputPassword) setIsShowInputPassword(false);
    setWifiPassword(selectedWifi.Password);
    // setNetworkSSID("");
  }, [selectedWifi]);

  // /**
  //  * @deprecated current info of the root cause is the current password field component is not able to display the value when on click the display button
  //  */
  // const OnClickShowPassword = () => {
  //   if (showPassword === 'text') {
  //     setShowPassword('password');
  //   } else {
  //     setShowPassword('text');
  //   }
  // };

  const OnKeyboardValueChangeHandler = (evt) => {
    const {value, type} = evt;

    switch (type) {
      case Password:
        setWifiPassword(value);
        break;
      case SSID:
        setNetworkSSID(value);
        break;
      default:
        break;
    }
  };

  const OnAutoConnectToggleHandler = useCallback(
    (evt) => {
      const {checked} = evt.currentTarget;
      SetSelectedWifi({
        ...selectedWifi,
        IsAutoConnect: checked,
      });
    },
    [selectedWifi],
  );

  const OnAutoConnectHiddenToggleHandler = useCallback((evt) => {
    const {checked} = evt.currentTarget;
    setIsAutoConnectHidden(checked);
  }, []);

  const OnClickActionHandler = useCallback(
    (evt) => {
      console.log('OnClickAction ', evt.target, wifiPassword);
      const {id, value} = evt.target;

      switch (id) {
        case ConnectButton: {
          if (wifiPassword || !isSelectedEncryptionOn) {
            dispatch(
              updateLoading({
                showLoading: true,
                loadingText: ConnectLoading,
              }),
            );
            const param = {...selectedWifi, Password: wifiPassword};
            SetIsConnecting({...selectedWifi});
            PostRequest(POST_CONNECT_TO_WIFI, param).then((response) => {
              dispatch(
                updateLoading({
                  showLoading: false,
                  loadingText: '',
                }),
              );
              SetIsConnecting(null);

              if (response.data !== WIFI_ERROR.NONE) {
                let alertMessage = '';
                switch (response.data) {
                  case WIFI_ERROR.INCORRECT_PASSWORD:
                    alertMessage = SYSTEM_SETTING.WIFI.ALLERT.PASSWORD_INCORRECT;
                    break;
                  case WIFI_ERROR.CONNECTION_TIMED_OUT:
                    alertMessage = SYSTEM_SETTING.WIFI.ALLERT.CONNECTION_TIME_OUT;
                    break;
                  default:
                    alertMessage = SYSTEM_SETTING.WIFI.ALLERT.PASSWORD_AND_SSID_INCORRECT;
                    break;
                }

                dispatch(
                  showAlert({
                    alertShow: true,
                    alertText: alertMessage,
                    alertStyle: ALERT_TYPE.ALERT_DANGER,
                  }),
                );
              } else SetSelectedWifi(null);
            });
          } else setIsShowInputPassword(true);
          break;
        }
        case Forget: {
          // if (wifiPassword || (! selectedWifi.IsEncryptionOn) ) {
          if (selectedWifi.HasBeenConnected) {
            const param = {
              Essid: selectedWifi.Name,
            };
            PostRequest(POST_FORGET_WIFI, param).then((response) => {
              if (response.data) {
                dispatch(
                  showAlert({
                    alertShow: true,
                    alertText: SYSTEM_SETTING.WIFI.ALLERT.SUCCESS_FORGET,
                    alertStyle: ALERT_TYPE.ALERT_INFO,
                  }),
                );
                SetSelectedWifi({...selectedWifi, Password: null, HasBeenConnected: false});
                changeWifiListValues({...selectedWifi, Password: null, HasBeenConnected: false});
              } else
                dispatch(
                  showAlert({
                    alertShow: true,
                    alertText: SYSTEM_SETTING.WIFI.ALLERT.FAILED_FORGET,
                    alertStyle: ALERT_TYPE.ALERT_DANGER,
                  }),
                );
            });
          }
          break;
        }
        case Password:
          dispatch(
            showKeyboard({
              keyboardValue: value || '',
              keyboardTitle: Password,
              keyboardPlaceholder: Password,
              keyboardCallBack: OnKeyboardValueChangeHandler,
              max: 63,
            }),
          );
          break;
        case SSID:
          dispatch(
            showKeyboard({
              keyboardValue: value || '',
              keyboardTitle: SSID,
              keyboardPlaceholder: SSID,
              keyboardCallBack: OnKeyboardValueChangeHandler,
              max: 63,
            }),
          );
          break;
        case CONNECT_ADD_NETWORK: {
          dispatch(
            updateLoading({
              showLoading: true,
              loadingText: ConnectLoading,
            }),
          );
          const param = {
            ...selectedWifi,
            Password: wifiPassword || '',
            Name: networkSSID,
            IsAutoConnect: isAutoConnectHidden,
          };
          SetIsConnecting({...selectedWifi});
          PostRequest(POST_CONNECT_TO_WIFI, param).then((response) => {
            dispatch(
              updateLoading({
                showLoading: false,
                loadingText: '',
              }),
            );
            SetIsConnecting(null);

            if (response.data !== WIFI_ERROR.NONE)
              dispatch(
                showAlert({
                  alertShow: true,
                  alertText: SYSTEM_SETTING.WIFI.ALLERT.PASSWORD_AND_SSID_INCORRECT,
                  alertStyle: ALERT_TYPE.ALERT_DANGER,
                }),
              );
            else SetSelectedWifi(null);
          });
          break;
        }
        default:
          break;
      }
    },
    [wifiPassword, selectedWifi, networkSSID, securityType, isAutoConnectHidden, isSelectedEncryptionOn],
  );

  const RowWifiConfigStyle = css({
    width: 'inherit',
    padding: '5px 0px',
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: parseInt(window.localStorage.getItem(FontSize), 10) || fontSize,
  });

  const ColWifiConfigStyle = css({
    width: 'inherit',
    padding: '5px 0px',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    fontSize: parseInt(window.localStorage.getItem(FontSize), 10) || fontSize,
  });

  const ForgotWifiButtonStyle = css({
    width: '150px',
    height: ButtonSize.defaultButtonHeight,
    backgroundColor: ButtonColor.defaultButtonColor,
    color: ButtonColor.buttonTextColor,
    border: 'none',
    borderRadius: roundCorner,
    margin: '0px 10px',
  });

  const ConnectedWifiButtonStyle = css({
    width: '150px',
    height: ButtonSize.defaultButtonHeight,
    backgroundColor: proteinConcentrationColor,
    color: ButtonColor.buttonTextColor,
    border: 'none',
    borderRadius: roundCorner,
    margin: '0px 10px',
  });

  const DisabledWifiButtonStyle = css({
    width: '150px',
    height: ButtonSize.defaultButtonHeight,
    backgroundColor: ButtonColor.buttonColorBackgroundDisable,
    color: ButtonColor.buttonTextColorDisable,
    border: 'none',
    borderRadius: roundCorner,
    margin: '0px 10px',
  });

  const onChangeSecurityType = (newSecurityType) => {
    setNewSecurityType(newSecurityType);
  };

  useEffect(() => {
    if (saveSecurity) {
      setSecurityType(newSecurityType);
      setNewSecurityType('');
      setSaveSecurity(false);
    }
  }, [saveSecurity]);

  const setChangeSecurityType = () => {
    setSaveSecurity(true);
    dispatch(hidePopUp());
  };

  const securityChange = () => {
    const popUpButton = [
      {
        id: OK,
        isPrimaryButton: true,
        onClick: setChangeSecurityType,
        label: OK,
      },
    ];
    const securitySelector = GenerateSequenceSelector(
      SECURITY_TYPES,
      selectedSecurityId,
      securityType,
      onChangeSecurityType,
      'security-dropdown-selection',
    );
    dispatch(
      showPopUp({
        popUpTitle: 'Security',
        popUpText: securitySelector,
        popUpButton,
      }),
    );
  };

  return (
    <>
      <div
        css={RowWifiConfigStyle}
        className="wifi-config"
      >
        {isAddNetwork && (
          <div className={COLUMN_FULL}>
            <InputField
              label={SSID}
              inputValue={networkSSID || ''}
              fullWidthInput
              onClick={OnClickActionHandler}
              disabled={!!isConnecting}
            />
            <InputField
              label={SECURITY}
              inputValue={securityType || ''}
              fullWidthInput
              onClick={securityChange}
              disabled={!!isConnecting}
            />
            {securityType !== SECURITY_TYPE.NONE && (
              <InputField
                label={Password}
                inputValue={wifiPassword || ''}
                fullWidthInput
                onClick={OnClickActionHandler}
                disabled={!!isConnecting}
                // type={showPassword}
                type="password"
              />
            )}
            <CheckBox
              id="auto_connect_wifi"
              onChange={OnAutoConnectHiddenToggleHandler}
              value={isAutoConnectHidden}
              defaultChecked={selectedWifi.IsAutoConnect}
              text={SYSTEM_SETTING.WIFI.CHECKBOX}
            />
          </div>
        )}
      </div>
      <div css={RowWifiConfigStyle}>
        {isAddNetwork && (
          <button
            type="button"
            css={isDisableSaveBtn ? DisabledWifiButtonStyle : ConnectedWifiButtonStyle}
            id={CONNECT_ADD_NETWORK}
            onClick={OnClickActionHandler}
            // disabled={isConnecting ? true : false}
            disabled={isDisableSaveBtn}
          >
            {SYSTEM_SETTING.WIFI.CONNECT.toUpperCase()}
          </button>
        )}
      </div>
      <div css={ColWifiConfigStyle}>
        {isShowInputPassword && (
          <div className={COLUMN_FULL}>
            <InputField
              label={Password}
              inputValue={wifiPassword || ''}
              fullWidthInput
              onClick={OnClickActionHandler}
              disabled={!!isConnecting}
              // type={showPassword}
              type="password"
            />
          </div>
        )}
        {!isShowInputPassword && !isAddNetwork && (
          <CheckBox
            id="auto_connect_wifi"
            onChange={OnAutoConnectToggleHandler}
            value={selectedWifi.IsAutoConnect}
            defaultChecked={selectedWifi.IsAutoConnect}
            text={SYSTEM_SETTING.WIFI.CHECKBOX}
          />
        )}
      </div>
      <div css={RowWifiConfigStyle}>
        {canForget ? (
          <button
            type="button"
            css={ForgotWifiButtonStyle}
            id={Forget}
            onClick={OnClickActionHandler}
            disabled={!!isConnecting}
          >
            {SYSTEM_SETTING.WIFI.FORGET.toUpperCase()}
          </button>
        ) : null}
        {!isAddNetwork && (
          <button
            type="button"
            css={ConnectedWifiButtonStyle}
            id={ConnectButton}
            onClick={OnClickActionHandler}
            disabled={!!isConnecting}
          >
            {SYSTEM_SETTING.WIFI.CONNECT.toUpperCase()}
          </button>
        )}
      </div>
    </>
  );
}

export default WifiConfig;
